import BookDemoButtonComponent, {
  IProps,
} from '@framework/ui/Organisms/ScheduleDemo/ScheduleDemoModal/BookDemoButton';
import BookDemoButtonLegacyComponent
  from '@framework/ui/Organisms/ScheduleDemo/ScheduleDemoModalLegacy/BookDemoButton';
import { useDataroomTenantContext } from '@dataroom/tenant/DataroomTenantContext';
import { dataRoomLogoMapping } from '../dataRoomLogoMapping';
import DataroomTenantConfig from '@/dataroom/app/config/DataroomTenantConfig';
import { getTimeZoneOption } from '@framework/timezone/helpers';
import { GMT0_TIME_ZONE } from '@framework/timezone/constants';

const BookDemoButton = ({
  legacy = false,
  ...props
}: Omit<IProps, 'tenant'> & {
  legacy?: boolean,
}) => {
  const Component = legacy ? BookDemoButtonLegacyComponent : BookDemoButtonComponent;
  const { tenant } = useDataroomTenantContext();
  const {
    defaultPhoneCountry,
    isStagesEnabled,
  } = DataroomTenantConfig.fromCode(tenant).options;

  const getDefaultFormValues = () => {
    if (isStagesEnabled) {
      return {
        timeZone: getTimeZoneOption(GMT0_TIME_ZONE),
      };
    }

    return null;
  };

  return (
    <Component
      tenant={ tenant }
      logoComponent={ dataRoomLogoMapping[tenant] }
      defaultPhoneCountry={ defaultPhoneCountry }
      getInitialFormValues={ getDefaultFormValues }
      { ...props }
    />
  );
};

export default BookDemoButton;
